// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__14A2w","Label":"Checkbox_Label__3wxSf"};